import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { FaInfoCircle, FaChevronUp } from 'react-icons/fa';

type Props = {
  readonly text: string | React.ReactNode;
  readonly changed?: boolean;
  readonly required?: boolean;
  readonly size?: string;
  /** Optional explanatory content shown in an inline expandable panel below the label (click icon or trigger to toggle) */
  readonly helpText?: React.ReactNode;
  /** Περιεχόμενο δεξιά του label (π.χ. κουμπί +/− επέκτασης) */
  readonly endAdornment?: React.ReactNode;
};

const FieldLabel = ({
  size,
  text,
  required = false,
  changed = false,
  helpText,
  endAdornment,
}: Props) => {
  const [helpExpanded, setHelpExpanded] = useState(false);
  const id = React.useId();

  const labelContent = (
    <>
      {text}
      {required && <span className="font-weight-bold text-danger">{' (*) '}</span>}
      {text ? ' : ' : ''}
    </>
  );

  return (
    <div
      className="field-label-wrapper"
      style={{ marginBottom: '3px', position: endAdornment ? 'relative' : undefined }}
    >
      <div className="d-flex align-items-center gap-1" style={{ minWidth: 0 }}>
        {size === 'lg' ? (
          <Form.Label lg={2} className="mb-0" style={{ minWidth: 0 }}>
            <span
              className={changed ? 'text-primary' : undefined}
              style={{
                display: 'block',
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
            >
              {labelContent}
            </span>
          </Form.Label>
        ) : (
          <Form.Label className="mb-0" style={{ minWidth: 0 }}>
            <span
              className={changed ? 'text-primary' : undefined}
              style={{
                display: 'block',
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
            >
              {labelContent}
            </span>
          </Form.Label>
        )}
        {helpText && (
          <button
            type="button"
            className="btn btn-link p-0 ms-1 align-baseline border-0 bg-transparent text-decoration-none d-inline-flex align-items-center gap-1"
            style={{ cursor: 'pointer', fontSize: 'inherit' }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setHelpExpanded((prev) => !prev);
            }}
            aria-expanded={helpExpanded}
            aria-controls={`${id}-help-panel`}
            id={`${id}-help-trigger`}
          >
            {!helpExpanded && <FaInfoCircle className="text-secondary" size={14} aria-hidden />}
            {helpExpanded && <FaChevronUp size={12} className="opacity-75" aria-hidden />}
          </button>
        )}
      </div>
      {/* Απόλυτη θέση ώστε να μην αυξάνει το ύψος του label / κενό προς το input */}
      {endAdornment && (
        <span
          className="d-inline-flex align-items-center"
          style={{ position: 'absolute', right: 0, top: 0, lineHeight: 1 }}
        >
          {endAdornment}
        </span>
      )}
      {helpText && helpExpanded && (
        <div
          id={`${id}-help-panel`}
          role="region"
          aria-labelledby={`${id}-help-trigger`}
          className="small text-muted mt-1 mb-1"
        >
          {helpText}
        </div>
      )}
    </div>
  );
};

export default React.memo(FieldLabel);
